/**
 * Одно и несколько прямоугольных выделений (Ctrl+мышь как в Excel).
 */

export function normalizeRange(sel) {
  if (!sel) return null;
  return {
    r0: Math.min(sel.r0, sel.r1),
    r1: Math.max(sel.r0, sel.r1),
    c0: Math.min(sel.c0, sel.c1),
    c1: Math.max(sel.c0, sel.c1),
  };
}

export function singleRange(r0, c0, r1 = r0, c1 = c0) {
  return normalizeRange({ r0, r1, c0, c1 });
}

export function clampRange(sel, rows, cols) {
  const b = normalizeRange(sel);
  if (!b) return null;
  return {
    r0: Math.max(0, Math.min(rows - 1, b.r0)),
    r1: Math.max(0, Math.min(rows - 1, b.r1)),
    c0: Math.max(0, Math.min(cols - 1, b.c0)),
    c1: Math.max(0, Math.min(cols - 1, b.c1)),
  };
}

export function primaryRange(ranges) {
  if (!ranges || !ranges.length) return null;
  return normalizeRange(ranges[ranges.length - 1]);
}

export function isInRanges(ranges, r, c) {
  if (!ranges) return false;
  for (const raw of ranges) {
    const b = normalizeRange(raw);
    if (!b) continue;
    if (r >= b.r0 && r <= b.r1 && c >= b.c0 && c <= b.c1) return true;
  }
  return false;
}

/** Заменить выделение одним range. */
export function replaceRanges(range) {
  const b = normalizeRange(range);
  return b ? [b] : [];
}

/** Ctrl: добавить range. */
export function addRange(ranges, range) {
  const b = normalizeRange(range);
  if (!b) return ranges || [];
  const prev = (ranges || []).map(normalizeRange).filter(Boolean);
  const without = prev.filter((x) => !(
    x.r0 === b.r0 && x.r1 === b.r1 && x.c0 === b.c0 && x.c1 === b.c1
  ));
  return [...without, b];
}

/**
 * Обновить последний range: якорь (ar,ac) → текущая клетка (r,c).
 */
export function setLastRangeFromAnchor(ranges, ar, ac, r, c) {
  const list = (ranges || []).map(normalizeRange).filter(Boolean);
  const next = normalizeRange({ r0: ar, c0: ac, r1: r, c1: c });
  if (!next) return replaceRanges({ r0: r, r1: r, c0: c, c1: c });
  if (!list.length) return [next];
  return [...list.slice(0, -1), next];
}

export function startRangeAt(r, c) {
  return [{ r0: r, r1: r, c0: c, c1: c }];
}

export function forEachCellInRanges(ranges, fn) {
  const seen = new Set();
  for (const raw of ranges || []) {
    const b = normalizeRange(raw);
    if (!b) continue;
    for (let row = b.r0; row <= b.r1; row += 1) {
      for (let col = b.c0; col <= b.c1; col += 1) {
        const key = `${row},${col}`;
        if (seen.has(key)) continue;
        seen.add(key);
        fn(row, col);
      }
    }
  }
}

export function rangesToLegacySel(ranges) {
  return primaryRange(ranges) || { r0: 0, r1: 0, c0: 0, c1: 0 };
}

/** Без служебных полей — в awareness. */
export function serializeRanges(ranges) {
  return (ranges || [])
    .map((raw) => normalizeRange(raw))
    .filter(Boolean)
    .map((b) => ({ r0: b.r0, r1: b.r1, c0: b.c0, c1: b.c1 }));
}
